import styled from "styled-components";

// Add these new styled components
export const MobileView = styled.div`
  @media (min-width: 769px) {
    display: none;
  }
`;

export const DesktopView = styled.div`
  display: none;

  @media (min-width: 769px) {
    display: block;
    padding: 0 20px;
  }
`;

export const DesktopHeader = styled.div`
  margin-bottom: 40px;
`;

export const DesktopTabs = styled.div`
  display: flex;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 30px;
`;

export const DesktopTabItem = styled.button`
  padding: 15px 30px;
  font-size: 16px;
  color: ${(props) => (props.active ? "#2ECF96" : "#818D88")};
  font-weight: ${(props) => (props.active ? "600" : "400")};
  background: none;
  border: none;
  border-bottom: ${(props) => (props.active ? "3px solid #2ECF96" : "none")};
  margin-right: 30px;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s ease;

  &:hover {
    color: #2ecf96;
  }
`;

export const DesktopAppContent = styled.div`
  display: flex;
`;
export const DesktopDashboardContent = styled.div`
  img {
    max-width: 100%;
    height: auto;
    margin-top: 20px;
  }
`;
export const CoachView = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  overflow: hidden;

  .coachImage {
    width: 270px;
    height: 180px;
    margin-right: 16px;
    border-radius: 15px;
    margin-top: 50px;

    @media screen and (max-width: 768px) {
      width: 110px;
      height: 110px;
    }

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .coachContent {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
  }
`;
export const DesktopImageColumn = styled.div`
  .app-mockup {
    max-width: 100%;
    display: block;
    @media screen and (min-width: 768px) {
      /* width: 350px;
      height: 550px; */
      margin-right: 250px;
      margin-top: 50px;
    }
  }
`;
export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 20px;
  margin-left: 100px;
`;
export const DashboardGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  margin-top: 20px;
  margin-left: 10px;
`;
export const DesktopFeaturesColumn = styled.div``;

export const DesktopFeatureTitle = styled.h3`
  font-size: 18px;
  color: #142c1f;
  margin: 20px 0 10px;
`;

export const DesktopFeatureText = styled.p`
  color: #818d88;
  margin: 0 0 20px;
`;

export const DesktopFeatureLabel = styled.span`
  background-color: #2ecf96;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
  margin-left: 10px;
`;

// Keep existing styled components below
export const Container = styled.div`
  background-color: #e5f5f2;
  height: 100%;
  border-radius: 20px;

  .main-div {
    background-color: white;
    border-radius: 20px;
    height: 100%;

    @media screen and (min-width: 768px) {
      /* height: calc(-100px + 100vh); */
      background: white;
    }
  }
`;
export const ContentSection = styled.div`
  padding: 20px 16px 2px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h3`
  color: #142c1f;
  margin: 12px auto;
  font-size: 16px;
  text-align: center;
  @media screen and (max-width: 768px) {
    width: 280px;
    line-height: 24px;
  }
`;

export const Tab = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 4px;
  width: 100%;
  max-width: 500px;
  height: 54px;
  background-color: #ffffff;
  position: relative;
  gap: 8px;
  border: 1.5px solid #e2e4e9;
  border-radius: 25px;
`;

export const TabItem = styled.button`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px;
  font-weight: ${(props) => (props.active ? "600" : "400")};
  color: ${(props) => (props.active ? "#2ECF96" : "#142C1F")};
  cursor: pointer;
  padding: 10px 0;
  border-radius: 22px;
  height: 46px;
  background: transparent;
  border: 2px solid ${(props) => (props.active ? "#44554C40" : "white")};
  box-shadow: ${(props) => (props.active ? "0px 2px 4px #02332A14" : "none")};
  transition: all 0.3s ease;
  outline: none;

  &:hover {
    color: #2ecf96;
  }
`;

export const TabContent = styled.div`
  margin-top: 24px;
  width: 100%;
  min-height: 200px;
  display: ${(props) => (props.active ? "block" : "none")};
  animation: fadeIn 0.5s ease;
  overflow: hidden;

  .coachImage {
    border: 15px;
    @media screen and (min-width: 768px) {
      display: flex;
      gap: 20px;
    }
    img {
      width: 100%;
      height: auto;
      border-radius: 15px;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const TabContentWrapper = styled.div`
  width: 100%;
  margin-top: 20px;
`;
export const Tile = styled.div`
  border: 1px solid #d0d5dd;
  border-radius: 16px;
  display: flex;
  gap: 10px;
  padding: 10px;
  margin-bottom: 15px;
`;
export const ContentDiv = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: column;
  width: 100%;
  h3 {
    text-align: left !important;
  }
  p {
    text-align: left !important;
    margin-bottom: 0 !important;
  }
`;
export const Circle = styled.div`
  width: 25px;
  height: 23px;
  background-color: #2ecf96;
  box-shadow: 0px 1px 2px #1018280d;
  border: 2px solid #ededed;
  border-radius: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    color: white;
    font-size: 14px;
    margin: 0;
    font-weight: bold;
  }
`;

export const Description = styled.p`
  color: #44554c;
  margin: 0 0 16px;
  text-align: center;
`;

export const RegularTitle = styled.h3`
  color: #142c1f;
  font-size: 16px;
`;
export const CoachTitle = styled.h3`
  color: #1d9d86;
  font-size: 12px;
  margin-top: 30px;
  text-align: left;
  @media screen and (max-width: 768px) {
    font-size: 16px;
    margin-top: 20px;
    margin-bottom: 5px;
  }
`;
export const CoachName = styled.h3`
  color: #142c1f;
  font-size: 22px;
  margin: 0 0 16px;
  text-align: left;
  @media screen and (max-width: 768px) {
    margin-bottom: 8px;
  }
`;
export const CoachDescription = styled.p`
  color: #44554c;
  margin: 0 0 10px;
  text-align: left;
`;
export const ListItem = styled.li`
  color: #44554c;
  margin: 0 0 12px;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 8px;

  .tick-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
  }

  .bold-text {
    color: #44554c;
    font-size: 14px;
  }
  p {
    color: #44554c;
  }
`;
